import axios from 'axios';
import config from './config';
import Cookies from "js-cookie";
import router from '@/router'
import { Message, MessageBox } from "element-ui";
import {transformParams} from '@/utils/objUtils.js'

export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseUrl,
      headers: config.headers,
      timeout: config.timeout,
      withCredentials: config.withCredentials
    })
    // request 请求拦截器
    instance.interceptors.request.use(
      config => {
        config.params = transformParams(config.params);
        config.data = transformParams(config.data);
        
        let jti = Cookies.get('jti')
        // 发送请求时携带token
        if (jti) {
          config.headers.jti = jti
        } else {
          // 重定向到登录页面
          router.push('/login')
        }
        return config
      },
      error => {
        // 请求发生错误时
        //console.log('request:', error)
        // 判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
          console.log('timeout请求超时')
        }
        // 需要重定向到错误页面
        const errorInfo = error.response
        if (errorInfo) {
          error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status; // 404 403 500 ...
          // /login
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
          // 重定向到登录页面
          var myDate = new Date()
          myDate.setTime(-1000) // 设置过期时间
          document.cookie = name+"=''; expires="+myDate.toGMTString();

          sessionStorage.removeItem("user")
          this.$router.push("/login")
          this.$api.login.logout().then((res) => {

          }).catch(function(res) {
          })

          })

          /*router.push({
            path: `/error/${errorStatus}`
          })
          */
        }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 响应拦截器
    instance.interceptors.response.use(
      response => {
        // console.log('RS:', response)
        const {data:{code, msg}} = response;
        
        if (code !== undefined && code !== 0) {
          Message({
            message: msg,
            type: 'error'
          })
          if (code === 70005) {
            Cookies.remove('jti');
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('userinfo');
            
            router.push({path:'/login'});
            return;
          }
          
          return Promise.reject(response.data);
        }

        return response.data
      },
      err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break
            case 401:
              err.message = '未授权，请登录'
              break
            case 403:
              err.message = '拒绝访问'
              break
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break
            case 408:
              err.message = '请求超时'
              break
            case 500:
              err.message = '服务器内部错误'
              break
            case 501:
              err.message = '服务未实现'
              break
            case 502:
              err.message = '网关错误'
              break
            case 503:
              err.message = '服务不可用'
              break
            case 504:
              err.message = '网关超时'
              break
            case 505:
              err.message = 'HTTP版本不受支持'
              break
            default:
          }
        }
       /* MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var myDate = new Date()
          myDate.setTime(-1000) // 设置过期时间
          document.cookie = name+"=''; expires="+myDate.toGMTString();

          sessionStorage.removeItem("user")
          this.$router.push("/login")
          this.$api.login.logout().then((res) => {

          }).catch(function(res) {
          })


        })*/
        console.error(err)
        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )
    // 请求处理
    instance(options).then(res => {
      resolve(res)
      return false
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/http/axios.js